const Menu = [
  {
    header: "Apps"
  },
  {
    title: "Dashboard",
    group: "apps",
    icon: "assessment",
    name: "Dashboard",
    visibility : true
  },
  {
    title: "Admin List",
    group: "apps",
    icon: "amp_stories",
    name: "Admin List",
    visibility : true
  },
  {
    title: "Student Information",
    group: "apps",
    icon: "list",
    name: "Student Information",
    visibility : true
  },
  {
    title: "Users",
    group: "apps",
    icon: "people",
    name: "Users",
    visibility : true
  },
  {
    title: "Edit Answer",
    group: "apps",
    icon: "question_answer",
    name: "Edit Answer",
    visibility : true
  }
]
// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase()
      let textB = y.title.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
  }
})

export default Menu